import { CSSProperties } from "react";
import { StateContext } from "context/context";
import styles from "./styles/grid-feature-large-center.module.scss";
import { GridImage } from "./interfaces";
import clsx from "clsx";
import { maskStyle } from "./data";

interface Props {
    gridSize: number;
}

const GridFeatureLargeCenter: React.FC<Props> = ({ gridSize }) => {
    const { state: { gridImages, event } } = StateContext();

    const grid = gridImages.slice(0, gridSize);

    return (
        <div id="grid-creation" className={styles.grid}
            style={{
                overflow: "hidden",
                ...(event.outlineImage?.url && event.useOutline) &&
                maskStyle(event.outlineImage.url)
            }}
        >
            {grid.map((image: GridImage, i: number) => (
                <div
                    key={i}
                    style={{
                        gridArea: `${(i === 0 && !event.featurePersonNumberOne && !event.featurePersonImage?.url) ? "m" : { i }}`,
                        ...(event.featurePersonNumberOne || event.featurePersonImage?.url) && { gridArea: image.type === "feature" ? "m" : { i } },
                        // "--value-x": `${Math.floor(Math.random() * 2001) - 1000}px`,
                        // "--value-y": `${Math.floor(Math.random() * 2001) - 1000}px`,
                        // "--value-r": `${Math.floor(Math.random() * 501) - 250}deg`,
                        // "--value-d": `${(Math.random() * 5 + 2).toFixed(1)}s`,
                        // "--value-b": `${(Math.random() * 10).toFixed(1)}px`,
                    } as CSSProperties}
                    className={clsx([styles["image-container"], {
                        // [styles.bounce]: animate, 
                        [styles.bordered]: (i === 0 && !event.featurePersonNumberOne && !event.featurePersonImage?.url) || image.type === "feature"
                    }])}>
                    {
                        (i === 0 && !event.featurePersonNumberOne && !event.featurePersonImage?.url) || image.type === "feature" ?
                            <div className={styles.extraBorder}>
                                <img src={image.image} alt="" className={styles.image} />
                            </div> :
                            <div className={styles.whiteBorder}>
                                <img src={image.image} alt="" className={styles.image} />
                            </div>
                    }
                </div>
            ))}
        </div>
    );
};

export default GridFeatureLargeCenter;
